/**
 * RawHtmlView view component.
 * @module components/View/RawHtmlView
 */

import React, { createRef } from 'react';
import {
  PagePlaceholderTitle,
  PagePlaceholderHeaderEnd,
} from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import ClimateClock from 'rer-theme/components/ClimateClock/ClimateClock';
import PropTypes from 'prop-types';
import DangerousHTML from 'rer-theme/helpers/DangerousHTML';
/**
 * RawHtmlView view component class.
 * @function RawHtmlView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const RawHtmlView = ({ content }) => {
  return (
    <div id="page-document" className="container px-4">
      {/* Header */}
      <div className="PageHeaderWrapper mb-4">
        <div className="row">
          <div className="title-description-wrapper col-lg-12">
            <PagePlaceholderTitle content={content}>
              <h1 className="mb-3" data-element="page-name">
                {content?.title}
              </h1>
            </PagePlaceholderTitle>
            <p className="description">{content?.description}</p>
          </div>
        </div>
        <PagePlaceholderHeaderEnd content={content} />
      </div>

      {/* HTML render */}
      <div className="raw-html-text mb-5">
        {/* <div dangerouslySetInnerHTML={{ __html: content.html_text }} /> */}
        <DangerousHTML html={content.html_text} />
        {/*nel caso inseriscano il climate clock per essere mostrato in home page, lo visualizzo nella view del raw html*/}
        <ClimateClock onlyJS={true} />
      </div>
    </div>
  );
};

export default RawHtmlView;
